import { Form, Input, message, Modal, Select, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";
import { ButtonFilled } from "reusableComponent/UIButtons";

const ClientFeedback = ({ isModalOpen, setIsModalOpen }) => {
  const userInfo = useSelector(getUserInfo);
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      const response = await axios.post(`clientfeedback`, values);

      if (response.status === 200 || response.status === 201) {
        message.success("Feedback submitted successfully!");
        setIsModalOpen(false);
        form.resetFields();
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Failed to submit feedback. Please try again."
      );
      console.error("Feedback Error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      title="Submit Feedback / Support Ticket"
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        setIsModalOpen(false);
      }}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          severity: "High", // Default value
          userId: userInfo?.userid,
          clientName: "ForesytsHR",
        }}
      >
        <Form.Item
          name="userId"
          label="User ID"
          rules={[{ required: true, message: "Please input your User ID!" }]}
        >
          <Input placeholder="Enter your User ID" disabled />
        </Form.Item>

        <Form.Item
          name="clientName"
          label="Client Name"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input placeholder="Enter client name" disabled />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label="Phone Number"
          rules={[
            { required: true, message: "Please input your phone number!" },
            {
              pattern: /^\d{10}$/,
              message: "Please enter a valid 10-digit phone number!",
            },
          ]}
        >
          <Input placeholder="Enter 10-digit phone number" maxLength={10} />
        </Form.Item>

        <Form.Item
          name="mailId"
          label="Email Address"
          rules={[
            { required: true, message: "Please input your email!" },
            { type: "email", message: "Please enter a valid email address!" },
          ]}
        >
          <Input placeholder="Enter email address" />
        </Form.Item>

        <Form.Item
          name="severity"
          label="Severity"
          rules={[{ required: true, message: "Please select severity level!" }]}
        >
          <Select placeholder="Select severity">
            <Option value="Low">Low</Option>
            <Option value="Medium">Medium</Option>
            <Option value="High">High</Option>
            <Option value="Critical">Critical</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please enter a description!" }]}
        >
          <Input placeholder="e.g., Unable to create task" />
        </Form.Item>

        <Form.Item
          name="information"
          label="Additional Information"
          rules={[{ required: true, message: "Please provide error details!" }]}
        >
          <TextArea rows={3} placeholder="e.g., Task save failed" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
          <Space>
            <ButtonFilled
              onClick={() => {
                form.resetFields();
                setIsModalOpen(false);
              }}
            >
              Cancel
            </ButtonFilled>
            <ButtonFilled type="primary" htmlType="submit" loading={loading}>
              Submit Ticket
            </ButtonFilled>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ClientFeedback;
